// extracted by css-extract-rspack-plugin
export default {"icon":"NoH0u"};